export const firebaseName = "Bimdatabasev5-01"
// export const bucketName="trident-bimdatabase-09122022"
// export const bucketName="my_project_data_2024v15"
export const bucketName="my_project_data_2024v20"